var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExcel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.12979372698077785 0 32.12979372698078 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "STYLE = COLOR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2H9.333A1.333 1.333 0 0 0 8 3.333V9l12 7 6 2.532L32 16V9z",
    fill: "#21a366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107c41",
    d: "M8 9h12v7H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.667 2H20v7h12V3.333A1.333 1.333 0 0 0 30.667 2z",
    fill: "#33c481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16H8v12.667A1.333 1.333 0 0 0 9.333 30h21.334A1.333 1.333 0 0 0 32 28.667V23z",
    fill: "#185c37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107c41",
    d: "M20 16h12v7H20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 7H8v19h8.667A1.337 1.337 0 0 0 18 24.667V8.333A1.337 1.337 0 0 0 16.667 7z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 8H8v19h7.667A1.337 1.337 0 0 0 17 25.667V9.333A1.337 1.337 0 0 0 15.667 8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 8H8v17h7.667A1.337 1.337 0 0 0 17 23.667V9.333A1.337 1.337 0 0 0 15.667 8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 8H8v17h6.667A1.337 1.337 0 0 0 16 23.667V9.333A1.337 1.337 0 0 0 14.667 8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Back Plate",
    d: "M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8z",
    fill: "#107c41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.533 21l3.236-5.014L3.805 11H6.19l1.618 3.187q.223.453.307.676h.021q.16-.362.335-.704L10.2 11h2.189l-3.04 4.958L12.466 21h-2.33l-1.869-3.5a2.922 2.922 0 0 1-.223-.468h-.028a2.207 2.207 0 0 1-.216.453L5.877 21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExcel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/excel.f387c8c7.svg";
export { ForwardRef as ReactComponent };